import React from 'react';

/**
 * 揽收站点 2.0 弹窗统一骨架（对齐 PRD 原型）。
 *
 * 原型约定：弹窗为三段式，header 与 footer 固定且各带一条分隔线，
 * 内容只在两线之间滚动；标题左侧有一根紫色竖条。
 * 抽成共享常量避免 5 个弹窗各写一份、后续调整时漏改。
 */

/** header 固定并带下分隔线 */
export const MODAL_HEADER_STYLE: React.CSSProperties = {
  borderBottom: '2px solid #efeaf7',
  paddingBottom: 16,
  marginBottom: 0,
};

/** footer 固定并带上分隔线 */
export const MODAL_FOOTER_STYLE: React.CSSProperties = {
  borderTop: '1px solid #eee9f6',
  paddingTop: 16,
  marginTop: 0,
};

/**
 * body 滚动区：滚动只发生在 header/footer 两条线之间。
 * @param maxHeight 按弹窗内容长度给，长表单用 70vh，短表单可更小
 */
export const modalBodyStyle = (maxHeight = '70vh'): React.CSSProperties => ({
  maxHeight,
  overflowY: 'auto',
  overflowX: 'hidden',
  paddingTop: 22,
  paddingBottom: 22,
  paddingRight: 8,
});

/** 标题：紫色竖条 + 加粗标题（原型 width:5 height:22 #7c4bf0） */
export const modalTitle = (text: React.ReactNode): React.ReactNode => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
    <span
      style={{
        width: 5,
        height: 22,
        background: '#7c4bf0',
        borderRadius: 3,
        display: 'inline-block',
        flex: '0 0 5px',
      }}
    />
    <span style={{ fontSize: 18, fontWeight: 800 }}>{text}</span>
  </div>
);
